import {
  signInWithEmailAndPassword
} from 'firebase/auth'
import { auth } from '../../plugins/firebase.js'

export const actions = {
  setUser(state, payload) {
    state.commit('setUser', payload);
  },
  setMenu(state, payload) {
    state.commit('setMenu', payload);
  },
  setMode(state, payload) {
    state.commit('setMode', payload);
  },
  async handleLogin(state, payload) {
    try {
      state.commit('LOGIN_PENDING');
      await signInWithEmailAndPassword(auth, payload.email, payload.password)
      localStorage.setItem("email_logged", payload.email)

      state.commit('LOGIN_SUCCESS');

      state.dispatch(
        'snackbar/success',
        {
          message: 'Autenticação concluída',
        },
        { root: true }
      );
      return true;
    } catch (error) {
      state.dispatch(
        'snackbar/error',
        {
          message: 'Falha na  Autenticação',
        },
        { root: true }
      );
      state.commit('LOGIN_ERROR');
    }
  }
};
